import script from "./OurProcess.vue?vue&type=script&setup=true&lang=ts"
export * from "./OurProcess.vue?vue&type=script&setup=true&lang=ts"

import "./OurProcess.vue?vue&type=style&index=0&id=0d3b30aa&lang=scss"

const __exports__ = script;

export default __exports__